module.exports = __webpack_public_path__ + "static/media/promotional_3.4a98acf8.png";